import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment-timezone";

import TimeLineItemEmail from "./TimeLineItemEmail.jsx";

import {
  abrirModalLerEmail,
  getDestinatariosLista,
  normalizaDestinatarios,
} from "../../../../store/reducers/emails/emailsActions";

class TimeLineItemEmailContainer extends React.Component {
  handleClickVisualizarEmail = () => {
    const threadsAgrupada = this.props.timelineItens
      .filter(item => item.email && item.email.threadId === this.props.email.threadId)
      .map(item => item.email);
    if (this.props.email.isEmailCadencia) {
      const threadNormalizada = threadsAgrupada.filter(item => item.mensagemId === this.props.email.mensagemId)[0];

      const emailsCopia = [];
      if (threadNormalizada.copia) {
        const lstEmails = threadNormalizada.copia.split(",");
        lstEmails.forEach(item => {
          emailsCopia.push({ nome: "", email: item });
        });
      }

      threadNormalizada.id = threadNormalizada.mensagemId;
      threadNormalizada.bodyOriginal = threadNormalizada.body;
      threadNormalizada.destinatariosLista = normalizaDestinatarios(threadNormalizada.destinatario);
      threadNormalizada.cc = emailsCopia;
      threadNormalizada.cco = [];

      threadNormalizada.emails = [threadNormalizada];
      threadNormalizada.destinatariosLista = getDestinatariosLista(threadNormalizada.emails);
      threadNormalizada.isIncompleta = false;

      threadNormalizada.to = threadNormalizada.destinatariosLista.map(({ nome: name, ...rest }) => ({ name, ...rest }));
      threadNormalizada.from = {
        name: threadNormalizada.remetente.nome,
        ...threadNormalizada.remetente,
      };
      threadNormalizada.preview = threadNormalizada.previa;
      threadNormalizada.subject = threadNormalizada.assunto;
      threadNormalizada.date = threadNormalizada.data;
      threadNormalizada.origemAcaoResposta = "TIMELINE";

      this.props.abrirModalLerEmail(threadNormalizada, true, this.props.idPublico);
    }

    if (!this.props.email.isEmailCadencia) {
      const threads = threadsAgrupada.map(item => item.threadCompleta);
      const threadsOrdenadas = threads.sort(
        (a, b) => new Date(moment(a.data).format()) - new Date(moment(b.data).format())
      );
      const threadNormalizada = threadsOrdenadas[0];
      threadNormalizada.origemAcaoResposta = "TIMELINE";
      if (threadsOrdenadas.length > 1) threadNormalizada.messages = threadsOrdenadas.slice(1);
      this.props.abrirModalLerEmail({ ...threadNormalizada, isIncompleta: false }, true, this.props.idPublico);
    }
  };

  mostrarEmailHtmlEmTexto = html => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.innerText.replace("  ", " ");
  };

  render() {
    return (
      <TimeLineItemEmail
        email={this.props.email}
        handleClickVisualizarEmail={this.handleClickVisualizarEmail}
        mostrarEmailHtmlEmTexto={this.mostrarEmailHtmlEmTexto}
        isTimelineAtividades={this.props.isTimelineAtividades}
      />
    );
  }
}

TimeLineItemEmailContainer.propTypes = {
  email: PropTypes.object,
  abrirModalLerEmail: PropTypes.func,
  timelineItens: PropTypes.array,
  idPublico: PropTypes.string,
  isTimelineAtividades: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  abrirModalLerEmail: (...args) => dispatch(abrirModalLerEmail(...args)),
});

export default connect(
  null,
  mapDispatchToProps
)(TimeLineItemEmailContainer);
